"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));
var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _SttHeading = _interopRequireDefault(require("../../SttTypography/SttHeading"));
var _SttNotification = _interopRequireDefault(require("../SttNotification"));
var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));
var _SttAlertTitle = _interopRequireDefault(require("../SttAlertTitle"));
var _SttButton = _interopRequireDefault(require("../../SttButton/SttButton"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _moment = _interopRequireDefault(require("moment"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _SttDotsButton = _interopRequireDefault(require("../../SttButton/SttDotsButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: '100%',
      cursor: 'grab'
    },
    content: {
      maxHeight: '270px',
      overflowY: 'auto',
      padding: theme.spacing(2),
      "&:last-child": {
        padding: theme.spacing(2)
      }
    },
    expand: {
      transform: 'rotate(180deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    expandOpen: {
      transform: 'rotate(0deg)'
    },
    notification: {
      display: 'flex',
      flexDirection: 'column'
    },
    heading: {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      wordBreak: 'break-word',
      maxWidth: theme.spacing(40),
      fontSize: '0.8rem'
    },
    alert: {
      margin: 0,
      marginBottom: theme.spacing(1),
      padding: theme.spacing(0.5),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      "& .MuiAlert-icon": {
        marginRight: theme.spacing(1)
      },
      "& .MuiAlert-message": {
        width: '100%'
      }
    },
    cardHeader: {
      padding: theme.spacing(0.2),
      paddingLeft: theme.spacing(1.5),
      borderBottom: '1px solid #d3d4d5',
      '& .MuiTypography-displayBlock': {
        display: 'block',
        fontWeight: 800
      }
    },
    button: {
      marginTop: theme.spacing(1)
    },
    alertTitle: {
      fontWeight: 800,
      wordBreak: 'break-word',
      maxWidth: theme.spacing(35),
      fontSize: '0.8rem'
    },
    divTitulo: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between'
    }
  };
});
var Notification = function Notification(_ref) {
  var notifications = _ref.notifications,
    setIdWebconferenciaSelecionada = _ref.setIdWebconferenciaSelecionada,
    setTituloWebconferencia = _ref.setTituloWebconferencia,
    setItemBiblioteca = _ref.setItemBiblioteca,
    _ref$startExpanded = _ref.startExpanded,
    startExpanded = _ref$startExpanded === void 0 ? true : _ref$startExpanded;
  var classes = useStyles();
  var _useState = (0, _react.useState)(startExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var handleExpandClick = function handleExpandClick() {
    setExpanded(function (e) {
      return !e;
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "divDragabble"
  }, /*#__PURE__*/_react["default"].createElement(_CardHeader["default"], {
    className: classes.cardHeader,
    action: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      className: (0, _clsx2["default"])(classes.expand, _defineProperty({}, classes.expandOpen, expanded)),
      onClick: handleExpandClick,
      onTouchStart: handleExpandClick,
      "aria-expanded": expanded
    }, /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null))),
    title: "Pr\xF3ximos eventos",
    titleTypographyProps: {
      variant: 'h3'
    }
  })), /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
    "in": expanded,
    timeout: "auto",
    unmountOnExit: true,
    orientation: "vertical"
  }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "notDragabble",
    style: {
      cursor: 'default'
    }
  }, notifications.map(function (n, index) {
    n.dataFormatada = (0, _moment["default"])(n.data).format('DD/MM/YYYY HH:mm');
    var evento = (0, _moment["default"])(n.data);
    var agora = (0, _moment["default"])();
    var diff = evento.diff(agora, 'minutes');
    var acessivel = diff <= 60;
    var dataAcessoEvento = evento.subtract(_moment["default"].duration('01:00:00')).format('DD/MM/YYYY HH:mm');
    return /*#__PURE__*/_react["default"].createElement(_SttNotification["default"], {
      severity: acessivel ? 'warning' : 'info',
      className: classes.alert,
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.divTitulo
    }, /*#__PURE__*/_react["default"].createElement(_SttAlertTitle["default"], {
      className: classes.alertTitle
    }, n.titulo), /*#__PURE__*/_react["default"].createElement(_SttDotsButton["default"], {
      onClick: function onClick() {
        setIdWebconferenciaSelecionada(n.id);
        setTituloWebconferencia(n.titulo);
        setItemBiblioteca(n.id_biblioteca_item);
      }
    })), /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h5",
      color: acessivel ? 'text' : 'secondary',
      className: classes.heading
    }, /*#__PURE__*/_react["default"].createElement("b", null, "Data/hora:"), " ", n.dataFormatada), /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h5",
      color: acessivel ? 'text' : 'secondary',
      className: classes.heading
    }, /*#__PURE__*/_react["default"].createElement("b", null, "Palestrante:"), " ", n.palestrante), /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h5",
      color: acessivel ? 'text' : 'secondary',
      className: classes.heading
    }, /*#__PURE__*/_react["default"].createElement("b", null, "Institui\xE7\xE3o:"), " ", n.instituicaoFormatada), !acessivel ? /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h5",
      color: "secondary",
      className: classes.heading
    }, "Evento acess\xEDvel a partir de ", dataAcessoEvento) : /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      type: "button",
      variant: "contained",
      color: "secondary",
      nomarginleft: "true",
      className: classes.button,
      onClick: n.onClick
    }, "Acessar evento"));
  })))));
};
var _default = Notification;
exports["default"] = _default;